import React, { FC, ReactNode } from "react";
import { ChakraProvider } from "@chakra-ui/provider";
import theme from "../theme";
import { ToastProvider } from "@chakra-ui/toast";

interface Props {
  children: ReactNode;
}

export const ThemeProvider: FC<Props> = ({ children }) => {
  return (
    <ChakraProvider theme={theme}>
      <ToastProvider />
      {children}
    </ChakraProvider>
  );
};
